export default {
  historicoProdutividade: {
    relatorio: 'Informe',
    historicoProdutividade: 'Informe de historial de productividad',
    regiao: 'Región',
    municipio: 'Contacto',
    carregando: 'Cargando...',
    gerandoRelatorio: 'Generando informe ...',
    falhaAoGerarRelatorio: 'Error al generar informe',
    ecosocial: 'Ecosocial',
    tecnicoResponsavel: 'Técnico responsable',
    naoPossui: 'No tiene',
    produtor: 'Productor',
    sim: 'Si',
    nao: 'No',
    statusCertificacaoOrganica: 'Estado de certificación orgánica',
    convencional: 'Convencional',
    emConversao: 'En conversión',
    brasil: 'BR (Brazil)',
    comunidadeEuropeia: 'CE (Comunidad Europea)',
    eua: 'NOP (Estados Unidos)',
    cultura: 'Cultura',
    comunidade: 'Comunidad',
    uf: 'Estado'
  }
};
